<template>
  <div>
    <div class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="requestInProgress"/>

        <div class="row">
          <div class="col-sm">
            <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width" />
          </div>

          <div class="col-sm form-container">
            <h3>Data Privacy Agreement</h3>
            <section>
              <label>Do you have existing data privacy agreement?</label>
              <div class="type-pass-content">
                <div class="form-check form-check-container">
                  <input @change="onChange($event)"
                    v-model="form.has_existing_agreement"
                    class="form-check-input"
                    type="radio"
                    name="agreement-type"
                    value=true>
                  <label class="form-check-label" for="privacy-agreement">
                    Yes
                  </label>
                </div>

                <div class="form-check">
                  <input @change="onChange($event)"
                    v-model="form.has_existing_agreement"
                    class="form-check-input"
                    type="radio"
                    name="agreement-type"
                    value=false>
                  <label class="form-check-label" for="privacy-agreement">
                    No
                  </label>
                </div>
              </div>
            </section>
            <br/><br/>
            <section>
              <label>{{ existingAgreementHelper }}</label>
            </section>
            <section>
              <vue-editor
                v-model="form.data_privacy_agreements"
                :editorToolbar="customToolbar"
                :editorOptions="optionsEditor">
              </vue-editor>
            </section>

            <br/>
            <section>
              <small v-if="error_message" class="form-text text-muted error-message">
                {{ error_message }}
              </small>
              <button @click="validateForm()" type="submit" class="btn btn-primary">
                Done
              </button>
            </section>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'

import { VueEditor } from 'vue2-editor'

import { ASSET_CREATE_ACCOUNT_2 } from '@/api/constants/ImageAssets'
import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  components: {
    CreateTitle,
    CreatePageImage,
    VueEditor,
    Loader
  },
  props: {
    companyId: String
  },
  data() {
    return {
      navbar_title: 'YeyPass for Business',
      page_title: 'Setup Agreements',
      image: ASSET_CREATE_ACCOUNT_2,
      existingAgreementHelper: 'Add your data privacy agreement',
      form: {
        data_privacy_agreements: '',
        has_existing_agreement: true,
      },
      privacy: {
        agreement_name: 'Data Privacy Agreement',
        content: '',
        link: '',
        other_agreement_name: 'none',
        type: 'wysiwyg',
        user_id: this.companyId
      },
      customToolbar: [
        [{'header': '2'}], ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, { 'list': 'bullet' }, 'link'],
      ],
      optionsEditor: {
        formats: ['bold','underline','italic','link','list','header'],
      },
      contentTemplate: '<p>We respect your individual right to privacy as much as we aim to ensure the safety and security of everyone in our company/building/establishment, so please read this data privacy agreement in order for you to understand how we process the information we collect from you with regards to this PASS.</p><p><br></p><p><b>WHAT WE COLLECT.</b> We collect basic information about you by request access to your details in this PASS. We require you to deposit a proof of identity (ID) for verification purposes when you enter our premises.</p><p><br></p><p><b>WHY WE COLLECT THEM.</b> This data is primarily for security measures. In case of any reported violations, we will use this data to investigate the issue.</p><p><br></p><p><b>HOW WE USE, STORE, AND RETAIN THEM.</b> Your data are kept at this service, YeyPass. Only company authorized personnel have access to them. Your data will be deleted two (2) years from the date of collection, unless required by the law to retain them for a longer period.</p><p><br></p><p><b>HOW YOU MAY EXERCISE YOUR RIGHTS.</b> You have the rights under the law regarding your personal data. Should you wish to exercise them, or if you have any questions, feel free to contact us at this email: ___________________________ or phone number: ______________________.</p><p><br></p><p>Thanks you.</p>',
      error_message: '',
      haveErrors: false,
      requestInProgress: false
    }
  },
  mounted() { },
  methods: {
    onChange(event) {
      if(event.target.value === 'true') {
        this.form.data_privacy_agreements = ''
        this.existingAgreementHelper = 'Add your data privacy agreement'
      } else {
        this.existingAgreementHelper = 'You can use our template, just edit it as needed. :)'
        this.form.data_privacy_agreements = this.contentTemplate
      }
    },
    validateForm() {
      this.error_message = ''
      if(this.form.data_privacy_agreements === '') {
        this.error_message = 'Please add your data privacy agreement'
        return
      }
      this.createAgreement()
    },
    createAgreement() {
      var self = this
      this.requestInProgress = true
      this.privacy['content'] = this.form.data_privacy_agreements
      var fields = {...this.privacy}
      api.createAgreement(fields)
        .then(data => {
          self.requestInProgress = false
          if (data.statusCode === 200) {
            self.redirectToPage()
          } else if(data.statusCode === 400){
            self.error_message = data.message
          }
        })
        .catch(err => {
          self.requestInProgress = false
          self.error_message = err
        })
    },
    redirectToPage() {
      this.$router.push('/dashboard/passes')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/containers/business_profile/CreateBusinessAgreements.vue